export class RequestsIssueTypeCountDto {
    all: number = 0;
    addNewItems: number = 0;
    changeData: number = 0;
    extentionMRPUpdate: number = 0;
}